<template>
  <v-btn
    v-if="$store.getters.turn"
    depressed
    rounded
    dark
    color="success"
    class="btn-header-cerrar-turno me-2"
    title="Contar la caja y cerrar el turno"
    aria-label="Cerrar turno"
    @click="$router.push('/pos/close-turn')"
  >
    <v-icon left class="btn-header-cerrar-turno__icono">mdi-store-check-outline</v-icon>
    <span class="d-none d-md-inline text-none font-weight-bold">Cerrar turno</span>
  </v-btn>
</template>

<script>
/** Botón verde de la cabecera para cerrar el turno: siempre a mano, en el POS y en el resto de pantallas. */
export default {
  name: "BotonCerrarTurno",
};
</script>

<style>
.btn-header-cerrar-turno.v-btn {
  background-color: var(--pos-verde) !important;
  height: 40px !important;
  min-width: 40px !important;
  padding: 0 14px !important;
  box-shadow: 0 2px 8px rgba(46, 125, 50, 0.45) !important;
  letter-spacing: 0;
}
.btn-header-cerrar-turno.v-btn:hover {
  background-color: #256628 !important;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.6) !important;
}
@media (max-width: 959px) {
  .btn-header-cerrar-turno.v-btn {
    width: 40px;
    padding: 0 !important;
  }
  .btn-header-cerrar-turno__icono.v-icon {
    margin: 0 !important;
  }
}
</style>
